module.exports = __webpack_public_path__ + "static/Razor2-dadd0fbc31732c80324b515716ca57a7.jpg";